/**
 * Converts the "YYYY-MM-DD" value of a date input into the date string the API
 * stores.
 *
 * `new Date("2026-08-15")` is parsed as UTC midnight, so `toDateString()` in
 * any timezone west of Greenwich renders the previous day — a post dated the
 * 15th was being saved as the 14th.
 */
export function toLocalDateString(inputValue: string): string {
  const [year, month, day] = inputValue.split("-").map(Number);
  if (!year || !month || !day) {
    return new Date(inputValue).toDateString();
  }
  return new Date(year, month - 1, day).toDateString();
}
